import { getAssetUrl } from '@/config/Assets'
import AudioEngine from '@/webgl/audio/AudioEngine'
import AudioSource from '@/webgl/audio/AudioSource'
import ILoadableAudio, { AudioAsset } from '@/webgl/audio/interfaces/ILoadableAudio'
import SubtitleFile from '@/webgl/audio/resources/SubtitleFile'
import { BytesResource } from '@/webgl/resources/Net'
export default class AudioFile implements ILoadableAudio {
  constructor(
    readonly engine: AudioEngine,
    readonly url: string,
    readonly subtitles: string = null
  ) {}

  async load(abort: AbortSignal): Promise<AudioAsset> {
    const byteResource: BytesResource = new BytesResource(getAssetUrl(this.url))
    const rawBuffer = await byteResource.load(abort)
    const buffer = await this.engine.context.decodeAudioData(rawBuffer)

    if (abort.aborted) return null

    const filename = this.url.split('/').pop().split('.').shift()
    const out: AudioAsset = {
      [filename]: {
        source: new AudioSource(this.engine, { buffer }),
      },
    }

    if (this.subtitles) {
      out[filename].track = await new SubtitleFile(this.subtitles).load(abort)
    }

    return out
  }
}
